<template>
    <hts-drawer
        v-model="visible"
        :custom="['header', 'footer']"
        :title="$t('labels.editDocument')"
        :submit="visibleSubmit"
        :undo-enable="true"
        :rules="rules.editDocumentVehicle"
        @close="closeOverSide"
        @undo="undo()">
        <div class="hts-vehicles-ignore-add-vehicle">
            <div class="hts-vehicles-ignore-add-vehicle__container-body">
                <hts-card :title="$t('labels.generalInformation')">
                    <div
                        class="grid gap-4"
                        :class="columnClass">
                        <hts-form-select
                            v-model="dataFormEditDocument.type"
                            :label="$t('labels.documentType')"
                            required
                            :items="listTypeDocument"
                            key-id="key"
                            key-label="value"
                            :color="props.color"
                            name="documentType"
                            prop="documentType"
                            @change="(data: any) => handleChangeType(data)" />
                        <hts-form-input
                            v-model="dataFormEditDocument.fileName"
                            :label="$t('labels.documentFileName')"
                            :color="props.color"
                            name="documentFileName"
                            prop="documentFileName" />
                        <hts-form-input
                            v-if="dataFormEditDocument.type === listTypeDocument[0].key"
                            v-model="dataFormEditDocument.insurancePrice"
                            :label="$t('labels.insurancePriceByYear')"
                            required
                            :color="props.color"
                            type="number"
                            name="insurancePriceByYear"
                            prop="insurancePriceByYear" />
                        <hts-form-date
                            v-if="dataFormEditDocument.type === listTypeDocument[0].key || dataFormEditDocument.type === listTypeDocument[1].key"
                            v-model="dataFormEditDocument.expiredDate"
                            required
                            :label="$t('labels.expiredDate')"
                            :color="color"
                            name="expiredDate"
                            prop="expiredDate" />
                        <!--            <hts-form-date -->
                        <!--              v-if="dataFormEditDocument.type===listTypeDocument[1].key" -->
                        <!--              v-model="dataFormEditDocument.expiredDate" -->
                        <!--              :label="$t('labels.expiredDate')" -->
                        <!--              required -->
                        <!--              :color="props.color" -->
                        <!--              name="expiredDate" -->
                        <!--              prop="expiredDate" -->
                        <!--            /> -->
                        <hts-form-input
                            v-model="dataFormEditDocument.description"
                            :label="$t('labels.description')"
                            :color="props.color"
                            name="description"
                            prop="description" />
                    </div>
                </hts-card>
            </div>
        </div>
        <template #footer>
            <div class="flex flex-row gap-5">
                <hts-form-button
                    icon-name="hi-check-icon"
                    icon-position="right"
                    color="primary"
                    type="submit"
                    :loading="creating">
                    {{ $t('labels.save') }}
                </hts-form-button>
                <hts-form-button
                    icon-name="hi-x-mark-icon"
                    icon-position="right"
                    color="error"
                    @click="visible = false">
                    {{ $t('labels.cancel') }}
                </hts-form-button>
            </div>
        </template>
        <hts-modal
            :show="showConfirmAddDocument"
            :title="$t('labels.confirmEditDocument')"
            type="confirm"
            :content="$t('labels.contentConfirmExpiredDateDocument')"
            @hide="showConfirmAddDocument = false"
            @confirm="handleSubmitFormEditDocument" />
    </hts-drawer>
</template>

<script lang="ts" setup>
import form from '../imports/form'
const { rules } = form

const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 2
  },
  documentInfo: {
    type: Object
  },
  type: {
    type: String,
    default: ''
  }
})

const _initForm = {
  document: '',
  fileName: '',
  type: '',
  privacy: '',
  description: '',
  expiredDate: '',
  insurancePrice: 0
}
const dataFormEditDocument = reactive<{ [key: string]: any }>({ ..._initForm })
const emits = defineEmits(['close', 'refreshDataTables'])
const visible = ref(false)
const creating = ref(false)
const openEditDocument = () => {
  visible.value = true
}
defineExpose({
  openEditDocument
})
const closeOverSide = () => {
  visible.value = false
}
function _formatDate (date: any) {
  if (!date) {
    return ''
  }
  const d = new Date(date)
  let month = '' + (d.getMonth() + 1)
  let day = '' + d.getDate()
  const year = d.getFullYear()

  if (month.length < 2) {
    month = '0' + month
  }
  if (day.length < 2) {
    day = '0' + day
  }

  return [year, month, day].join('-')
}
watch(props, () => {
  Object.assign(dataFormEditDocument, {
    ...props.documentInfo,
    expiredDate: _formatDate(props.documentInfo?.expiredDate),
    expiredDateRegistry: _formatDate(props.documentInfo?.expiredDateRegistry)
  })
})
const undo = () => {
  Object.assign(dataFormEditDocument, { ...props.documentInfo })
}
const listTypeDocument = [
  {
    key: 'INSURANCE',
    value: $t('labels.insurance')
  },
  {
    key: 'REGISTRY',
    value: $t('labels.registry')
  },
  {
    key: 'OTHER',
    value: $t('labels.other')
  }
]
const showConfirmAddDocument = ref(false)

const visibleSubmit = () => {
  if (
    dataFormEditDocument.type &&
    ['REGISTRY', 'INSURANCE'].includes(dataFormEditDocument.type) &&
    dataFormEditDocument.expiredDate &&
    new Date(dataFormEditDocument.expiredDate + ' 23:59:59').getTime() < new Date().getTime()
  ) {
    showConfirmAddDocument.value = true
  } else {
    handleSubmitFormEditDocument()
  }
}

const handleChangeType = (data: any) => {
  if (data.length > 0) {
    dataFormEditDocument.type = data[0].key
  }
}

const handleSubmitFormEditDocument = () => {
  const api = $urlPartner.vehicle.vehicle.updateDocument
  $api(api, { uriParams: { ID: props.documentInfo?._id }, body: { ...dataFormEditDocument } }).then((data) => {
    const resData: any = data?.data.value
    if (resData.success) {
      process.client && $toast().success($t('notifications.editSuccessDocument'))
      emits('close')
      emits('refreshDataTables')
      visible.value = false
      showConfirmAddDocument.value = false
    }
  })
}

const columnClass = computed(() => {
  if ($lodash.inRange(props.column, 1, 12)) {
    return `grid-cols-${props.column}`
  }
  return 'grid-cols-1'
})
</script>
